import { CharTypeId } from "rl-common/consts";
import { DealScopedOptions, DocumentOptions, RevisionStatus } from "rl-common/services/entity-config/entity-config.models";

export class EntityConfigUtil {
	private static documentOptions: number[] = [
		DocumentOptions.none,
		DocumentOptions.generatesDoc,
		DocumentOptions.sendForEsig,
		DocumentOptions.sendForEsigPartiesOnly,
		DocumentOptions.esigComplete
	];

	private static dealScopedOptions: number[] = [
		DealScopedOptions.Disabled,
		DealScopedOptions.Enabled,
		DealScopedOptions.OneToOne
	];

	private static revisionStatusOptions: number[] = [
		RevisionStatus.InSetup,
		RevisionStatus.Complete,
		RevisionStatus.Approved,
		RevisionStatus.InRevision
	]

	private static invoiceRevisionStatusOptions: number[] = [
		RevisionStatus.InSetup,
		RevisionStatus.FinancialDocComplete,
		RevisionStatus.FinancialDocPosted,
		RevisionStatus.FinancialDocCleared
	]

	private static generatedPaymentRevisionStatusOptions: number[] = [
		RevisionStatus.Approved,
		RevisionStatus.Paid,
		RevisionStatus.Release,
		RevisionStatus.Hold
	]

	static readonly GeneratedPaymentProcessName = "Generated Payment Process";

	static getDocumentOptions() {
		return this.documentOptions;
	}

	static getDealScopedOptions() {
		return this.dealScopedOptions;
	}

	static getRevisionStatus(charTypeId: number, processName?: string) {
		if (charTypeId === CharTypeId.Invoice && processName === EntityConfigUtil.GeneratedPaymentProcessName) {
			return this.generatedPaymentRevisionStatusOptions;
		}
		if (charTypeId === CharTypeId.Invoice) {
			return this.invoiceRevisionStatusOptions;
		}
		return this.revisionStatusOptions;
	}
}